import React from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import TouchableNative from '../../design/components/TouchableNative';
import Text from '../../design/components/Text';
import { trackButtonPress } from '../utilities/gatracker';
import Checkbox from '@mui/material/Checkbox';
import { withTheme } from '../../design/styles/useThemeContext';
import { withStyles } from '@mui/styles';
import { designConstants } from '../../design/styles';

const ColoredCheckbox = withStyles({
  root: (props) => ({
    color: props.inactiveColor,
    '&.Mui-checked': {
      color: props.activeColor,
    },
  }),
  checked: {},
})((props) => {
  return <Checkbox color="default" {...props} />;
});

class CheckBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  onPress = (event) => {
    console.log('CHECKBOXONPRESS');
    trackButtonPress('Checkbox ' + (this.props.tag || this.props.label));
    this.props.onPress(event);
  };

  render() {
    const { colors } = this.props.theme;
    let color = colors.buttonBlue;
    if (this.props.white) {
      color = colors.defaultBackground;
    }
    return (
      <TouchableNative
        style={this.props.style}
        onPress={this.onPress}
        onLongPress={this.props.onLongPress}
      >
        <View
          style={[
            { ...this.props.style },
            styles.container,
            {
              paddingLeft:
                this.props.textLeft && designConstants.paddings.edgePadding,
              paddingRight:
                this.props.textLeft && designConstants.paddings.edgePadding,
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
            },
          ]}
        >
          {this.props.textLeft && (
            <View
              style={{
                flexDirection: 'column',
                flex: 1,
                flexWrap: 'wrap',
                marginLeft: 5,
              }}
            >
              <Text>{this.props.label}</Text>
              {this.props.secondaryLabel && (
                <Text style={{ color: colors.textSecondary, fontSize: 12 }}>
                  {this.props.secondaryLabel}
                </Text>
              )}
            </View>
          )}
          <ColoredCheckbox
            checked={this.props.checked}
            activeColor={colors.buttonBlue}
            inactiveColor={colors.textSecondary}
          />

          {!this.props.textLeft && this.props.label !== '' && (
            <Text style={{ flex: 1, flexWrap: 'wrap' }}>
              {this.props.label}
            </Text>
          )}
        </View>
      </TouchableNative>
    );
  }
}

CheckBox.propTypes = {
  onPress: PropTypes.func.isRequired,
  onLongPress: PropTypes.func,
  label: PropTypes.string.isRequired,
  secondaryLabel: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  draggable: PropTypes.bool,
  textLeft: PropTypes.bool,
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    minHeight: 48,
    backgroundColor: 'transparent',
  },
});

export default withTheme(CheckBox);
